/**
 * Ikaros promo popup.
 *
 * Deliberately quiet: waits, shows once, and remembers a dismissal. The
 * frequency and delay are section settings so the merchant can tune it
 * without code.
 *
 * It never interrupts a purchase. On the cart and checkout paths it stays
 * shut - someone already buying does not need to be told about a delivery
 * threshold they are about to see in the totals anyway.
 */

(() => {
  const root = document.querySelector('[data-ikpop]');
  if (!root) return;

  const frequency = root.dataset.frequency || 'session';
  const key = root.dataset.key || 'ikaros-promo-v1';
  const delay = (parseInt(root.dataset.delay, 10) || 0) * 1000;

  // Never over a cart or checkout page.
  if (/\/(cart|checkouts?)(\/|$|\?)/.test(window.location.pathname)) return;

  const store = frequency === 'forever' ? window.localStorage : window.sessionStorage;

  function seen() {
    if (frequency === 'always') return false;
    try {
      return store.getItem(key) === '1';
    } catch (e) {
      return false; // private mode: show it, losing the memory is better than losing the message
    }
  }

  function remember() {
    if (frequency === 'always') return;
    try {
      store.setItem(key, '1');
    } catch (e) {
      /* ignore */
    }
  }

  let lastFocus = null;

  function open() {
    if (seen()) return;
    lastFocus = document.activeElement;
    root.hidden = false;
    document.body.style.overflow = 'hidden';
    const first = root.querySelector('.ikpop__btn, .ikpop__x');
    if (first) first.focus({ preventScroll: true });
    document.addEventListener('keydown', onKey);
  }

  function close() {
    root.hidden = true;
    document.body.style.overflow = '';
    remember();
    document.removeEventListener('keydown', onKey);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function onKey(e) {
    if (e.key === 'Escape') close();
  }

  root.querySelectorAll('[data-ikpop-close]').forEach((el) =>
    el.addEventListener('click', close)
  );

  if (!seen()) {
    window.setTimeout(open, delay);
  }
})();
